import { styled } from "styled-components"
import { theme } from "../../../styles/Theme"
import { css } from "styled-components"
import { Link } from "react-scroll"


// Menu
const MenuItem = styled.li`/* кагда ыл на 36 строке то этот элемент ничего не знал про маску, поэтому нужно перенести его ниже. Нужно следить за порядком компонент который мы переиспользуем, они всегда должны объявлены выше. */
position: relative;
/* &-селектор амперсант-это родительсикй элемент. */
`

const Mask = styled.span`
position: absolute;
top:0;
left: 0;
display: inline-block;
height: 50%;
overflow: hidden;
/* outline: 1px solid red; */
color: ${theme.colors.accent};
transition: ${theme.animations.transition};
& + & {
    top: 50%;
    span {
        display: inline-block;
        transform: translateY(-50%);
    }
}
`

const NavLink = styled(Link)`
font-family: 'Josefin Sans', sans-serif;
font-weight: 400;
font-size: 20px;
text-align: center;
/* color: #e7e7e7; */
color: transparent;/* этот засранец которого я искал чтобы спрятать фиолетовый текст.Потому что мы оставили слово item в ссылке?! */

&::before {
    content: "";
    display: inline-block;
    height: 2px;
    background-color: ${theme.colors.accent};
    position: absolute;
    top: 50%;
    left: -10px;
    right: -10px;
    z-index: 1;

    transform: scale(0);
    transition: ${theme.animations.transition};
}


&:hover, &.active {
    &::before {
        transform: scale(1);
    }
    ${Mask} {
        transform: skewX(12deg) translateX(5px);
        color: ${theme.colors.font};
        & + ${Mask} { 
        transform: skewX(12deg) translateX(-5px);
    }
    }
}
`




// Mobile Menu
/* у нас в браузере-разраба есть 2 меню, для мобилок и десктопа. так быть не должно. */
const MobileMenu = styled.nav`
`
const MobileMenuPopup = styled.div<{isOpen: boolean}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    background-color: rgba(31, 31 ,32, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-100%);
    transition: 0.7s ease-in-out;
    

    ul {
        display: flex;
        gap: 10px;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        transition: 0.99s ease-in-out;
       }

       ${props => props.isOpen && css<{isOpen: boolean}>`
    transform: translateY(0);

    & ul {
        gap: 30px;
    }
    `}
`

const BurgerButton = styled.button<{isOpen: boolean}>`
    position: fixed;
    top: -100px;
    right: -100px;
    width: 200px;
    height: 200px;
    z-index: 9999999;

    span {
        display: block;
        width: 36px;
        height: 2px;
        background-color: ${theme.colors.font};
        position: absolute;
        left: 40px;
        bottom: 50px;


        ${props => props.isOpen && css<{isOpen: boolean}>`
        background-color: rgba(255, 255, 255, 0);/* тут не меняем на opacity иначе задав его для спана все псевдоэлементы станут прозрачными. opacity для эоемента и всего что в нем лежит, а задав цвет только для него можно чтото сделать.  */
    `}

        &::before {
            content: "";
            display: block;
            width: 36px;
            height: 2px;
            background-color: ${theme.colors.font};
            position: absolute;
            transform: translateY(-10px);
            ${props => props.isOpen && css<{isOpen: boolean}>`
            transform: rotate(-45deg) translateY(0);
            `}
        }
        &::after {
            content: "";
            display: block;
            width: 24px;
            height: 2px;
            background-color: ${theme.colors.font};
            position: absolute;
            transform: translateY(10px);
            ${props => props.isOpen && css<{isOpen: boolean}>`
            transform: rotate(45deg) translateY(0);
            width: 36px;
            `}
        }

    }
`
// Desktop Menu
const DesktopMenu = styled.nav`
    ul {
        display: flex;
        gap: 30px;
        justify-content: center;
    }
`


export const S = {
    NavLink,
    MenuItem,
    Mask,
    MobileMenu,
    MobileMenuPopup,
    BurgerButton,
    DesktopMenu

}